import FormContentIdAndHash from '../../../domain/form/FormContentIdAndHash'
import formsBaseUrl from './baseUrl'
import fetchAuthorized from '../authorization/fetchAuthorized'
import { com } from '@eidu/web'
import FormContent = com.eidu.sharedlib.form.FormContent
import formContentIdFromString = com.eidu.sharedlib.entity.kind.form.formContentIdFromString
import CreateFormRequest = com.eidu.sharedlib.form.CreateFormRequest
import encodeCreateFormRequestToJson = com.eidu.sharedlib.form.encodeCreateFormRequestToJson

type PostFormParameters = {
  formId: string
  initialContent: FormContent
}

const postForm = async ({ formId, initialContent }: PostFormParameters): Promise<FormContentIdAndHash> => {
  const request = encodeCreateFormRequestToJson(new CreateFormRequest(formId, initialContent))
  const response = await fetchAuthorized(
    (authContext) => `${formsBaseUrl}/organizations/${authContext.organizationId}/forms`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: request,
    }
  )
  const responseJson = await response.json()
  if (response.status !== 200) throw Error(responseJson.message)

  return { contentId: formContentIdFromString(responseJson.contentId), contentSha256: responseJson.contentSha256 }
}

export default postForm
